import { useState, useCallback } from 'react'
import { getFeaturedBreaks } from 'services/break'

export const useGating = brk => {
  const [stepLocked, setStepLocked] = useState(
    !!(brk.hasAgeGating || brk.hasYesNoGate),
  )
  const [showRelatedBreaks, setShowRelatedBreaks] = useState(false)
  const [relatedBreaks, setRelatedBreaks] = useState([])

  const handleNoClick = useCallback(async () => {
    try {
      const response = await getFeaturedBreaks({ limit: 14, sponsoredOnly: true })
      const featured = (response?.detail ?? []).map(b => ({ ...b, type: 'featuredBreaks' }))
      setShowRelatedBreaks(true)
      setRelatedBreaks(featured)
    } catch (e) {
      console.log(e)
      setShowRelatedBreaks(true)
      setRelatedBreaks([])
    }
  }, [])

  const handleYesClick = useCallback(() => {
    setStepLocked(false)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return {
    stepLocked,
    setStepLocked,
    showRelatedBreaks,
    relatedBreaks,
    handleNoClick,
    handleYesClick,
  }
}
